export default __webpack_public_path__ + "static/media/emoji.70360314.png";